import { Team } from '../models';
import { TeamRepository } from '../repositories';

export class GetPublicTeamsUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(limit: number, offset: number): Promise<Team[]> {
    return this.teamRepository.getPublicTeams(limit, offset);
  }
}
